import { render } from "./PaymentMethodModal.vue?vue&type=template&id=58f9a9e6&scoped=true"
import script from "./PaymentMethodModal.vue?vue&type=script&lang=js"
export * from "./PaymentMethodModal.vue?vue&type=script&lang=js"

import "./PaymentMethodModal.vue?vue&type=style&index=0&id=58f9a9e6&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f9a9e6"]])

export default __exports__